import * as React from "react";

import { ClickableToggleDisplay } from "../../../../../App/Common/Components/FormComponents";
import { PreferredLocale } from "../../../../../utils/locales";
import { HTMLEditor } from "../../../html-editor/Editor.container";
import { HTMLRenderer } from "../../../html-editor/Renderer";
import { IHTMLEditorProps, IUploadedImgResponse } from "../../../html-editor/types";

interface IEditTaskWrapperContentProps {
  canEdit: boolean;
  canToggle: boolean;
  content: Nullable<string>;
  currentLocale: PreferredLocale;
  getContent: () => string;
  placeholderText?: string;
  setContent: (content: string, currentLocale: PreferredLocale) => void;
  toggleEdit: () => void;
  uploadImg?: (file: File) => Promise<IUploadedImgResponse>;
}

interface IDisplayContentProps {
  canToggle: boolean;
  display: boolean;
  toggle: () => void;
}

const DisplayContent: React.SFC<IDisplayContentProps> = props =>
  props.canToggle ? (
    <ClickableToggleDisplay onClick={props.toggle} shouldDisplay={props.display} children={props.children} />
  ) : (
    <div children={props.children} />
  );

export class EditTaskWrapperContent extends React.Component<IEditTaskWrapperContentProps> {
  public containerRef = React.createRef<HTMLDivElement>();

  public editorShouldAutoSave = (newProps: IHTMLEditorProps, oldProps: IHTMLEditorProps): boolean => {
    const { canEdit, canToggle } = this.props;
    return canEdit && canToggle && newProps.currentLocale !== oldProps.currentLocale;
  };

  public editorShouldResetState = (newProps: IHTMLEditorProps, oldProps: IHTMLEditorProps): boolean => {
    return newProps.initialContent !== oldProps.initialContent || newProps.currentLocale !== oldProps.currentLocale;
  };

  public render() {
    const { canEdit, canToggle, content, currentLocale, getContent, setContent, toggleEdit } = this.props;
    return (
      <>
        {canEdit && canToggle && (
          <div ref={this.containerRef}>
            <HTMLEditor
              initialContent={content || ""}
              currentLocale={currentLocale}
              getContent={getContent}
              setContent={setContent}
              shouldAutoSave={this.editorShouldAutoSave}
              shouldResetState={this.editorShouldResetState}
              shouldAutoFocus={true}
              containerRef={this.containerRef}
            />
          </div>
        )}
        <DisplayContent canToggle={canToggle} display={!canEdit} toggle={toggleEdit}>
          <HTMLRenderer source={content || (canToggle && this.props.placeholderText) || null} />
        </DisplayContent>
      </>
    );
  }
}
